import api from '../store/apiClient';

export const paymentService = {
  initializeFlutterwave: async (orderId, customer) => {
    const { data } = await api.post('/payments/flutterwave/initialize', { orderId, customer });
    return data;
  },

  initializeSquad: async (orderId, customer) => {
    const { data } = await api.post('/payments/squad/initialize', { orderId, customer });
    return data;
  },

  verifyFlutterwave: async (txRef) => {
    const { data } = await api.post('/payments/flutterwave/verify', { txRef });
    return data;
  },

  verifySquad: async (txRef) => {
    const { data } = await api.post('/payments/squad/verify', { txRef });
    return data;
  },

  getBankTransferDetails: async (orderId, currency) => {
    const { data } = await api.post('/payments/bank-transfer/details', { orderId, currency });
    return data;
  },

  uploadBankTransferReceipt: async (orderId, file) => {
    const formData = new FormData();
    formData.append('orderId', orderId);
    formData.append('file', file);
    const { data } = await api.post('/payments/bank-transfer/upload-receipt', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
};
